import React from 'react';
import styled from 'styled-components';

// --- Styled Components ---
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(17, 24, 39, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-Index: 3000;
`;

const ModalContent = styled.div`
  background-color: ${props => props.theme.colors.background};
  padding: 2.5rem;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  box-shadow: ${props => props.theme.shadows.soft};
  border: 3px solid ${props => props.theme.colors.warning};
`;

const WarningIcon = styled.div`
  width: 70px;
  height: 70px;
  margin: 0 auto 1.5rem;
  background-color: ${props => props.theme.colors.warning};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  color: ${props => props.theme.colors.textPrimary};
  font-weight: bold;
`;

const ModalTitle = styled.h2`
  font-family: ${props => props.theme.typography.titleFamily};
  font-size: 1.75rem;
  color: ${props => props.theme.colors.secondary};
  margin: 0 0 1.5rem 0;
  text-align: center;
`;

const WarningText = styled.p`
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 1.1rem;
  color: ${props => props.theme.colors.text};
  margin: 0 0 1.5rem 0;
  text-align: center;
  line-height: 1.6;
`;

const InfoBox = styled.div`
  background-color: ${props => props.theme.colors.surface};
  padding: 1.5rem;
  border-radius: ${props => props.theme.borderRadius};
  margin-bottom: 2rem;
  border-left: 4px solid ${props => props.theme.colors.warning};
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const InfoLabel = styled.span`
  font-weight: 600;
  color: ${props => props.theme.colors.secondary};
  font-size: 0.95rem;
`;

const InfoValue = styled.span`
  color: ${props => props.theme.colors.text};
  font-size: 0.95rem;
  text-align: right;
  max-width: 60%;
  word-break: break-word;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

const Button = styled.button`
  font-family: ${props => props.theme.typography.fontFamily};
  padding: 0.875rem 2rem;
  border: none;
  border-radius: ${props => props.theme.borderRadius};
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 140px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${props => props.theme.shadows.soft};
  }
`;

const CancelButton = styled(Button)`
  background-color: ${props => props.theme.colors.lightGray};
  color: ${props => props.theme.colors.secondary};
  
  &:hover {
    background-color: #D1D5DB;
  }
`;

const ContinueButton = styled(Button)`
  background-color: ${props => props.theme.colors.warning};
  color: ${props => props.theme.colors.textPrimary};
  
  &:hover {
    background-color: #F59E0B;
  }
`;

// --- Component ---
const A3WarningModal = ({ isOpen, data, onContinue, onCancel }) => {
  if (!isOpen || !data) return null;

  return (
    <ModalOverlay>
      <ModalContent className="axon-modal-sheet">
        <WarningIcon>⚠️</WarningIcon>
        <ModalTitle>¡ATENCIÓN! Título en Mercado A3</ModalTitle>
        <WarningText>
          El cliente tiene títulos de esta especie en el mercado A3. 
          Por favor, verifique antes de continuar.
        </WarningText>
        
        <InfoBox>
          <InfoRow>
            <InfoLabel>Cliente:</InfoLabel>
            <InfoValue>{data.nombreCliente}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Nro Comitente:</InfoLabel>
            <InfoValue>{data.nroComitente}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Especie:</InfoLabel>
            <InfoValue>{data.nombreEspecie}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Código:</InfoLabel>
            <InfoValue>{data.codigoEspecie}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Cantidad en A3:</InfoLabel>
            <InfoValue style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
              {data.cantidad.toLocaleString('es-AR')} VN
            </InfoValue>
          </InfoRow>
        </InfoBox>

        <ButtonContainer className="axon-modal-actions">
          <CancelButton onClick={onCancel}>
            Cancelar Operación
          </CancelButton>
          <ContinueButton onClick={onContinue}>
            Continuar de todos modos
          </ContinueButton>
        </ButtonContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default A3WarningModal;
